export const DEFAULT_DEVICE_SETTINGS = {
  mobile: true,
  tablet: true,
  desktop: true,
}
